const preMatchModel = {
  state: {
    redirectURLWin: '',
  },
  reducers: {
    setData(state, payload) {
      return { ...state, [payload.name]: payload.data };
    },
  },
};

export default preMatchModel;
